import React from 'react';
import Text from './base';

const SmallUppercase = props => (
  <Text defaultTag="small" variant="smallUppercase" {...props} />
);

export default SmallUppercase;
